export default __webpack_public_path__ + "static/media/fphlp.f4c3dca1.pdf";